type StartEvalCallback = (direction: string) => void

const startEval = (callback: StartEvalCallback = () => {}): void => {
  const promo = document.querySelector<HTMLElement>('.start-eval')
  if (!promo) return

  const promoBtn = promo.querySelector('#amp-ira-rollover-eval-get-started')
  const slideShow = document.querySelector<HTMLElement>(
    '.swiper-container.rollover-swiper'
  )
  const aboutLink = document.querySelector<HTMLElement>('.about-link')
  const prevButton = document.querySelector('.swiper-button-prev')

  promoBtn?.addEventListener('click', e => {
    e.preventDefault()
    promo.style.display = 'none'
    if (slideShow) slideShow.style.display = 'block'
    if (aboutLink) aboutLink.style.display = 'block'
    const direction = 'start'
    callback(direction)
  })

  // set the previous swiper to go back to landing page if on question one
  prevButton?.addEventListener('click', () => {
    if (document.rollover.state === 1) {
      promo.style.display = 'block'
      if (slideShow) slideShow.style.display = 'none'
      if (aboutLink) aboutLink.style.display = 'none'
    } else {
      const direction = 'prev'
      callback(direction)
    }
  })
}

export { startEval }
